// src/constants/index.ts
import { PublicKey } from '@solana/web3.js';
import type { BaseRequirements } from '../types/book';

// Token configuration
export const TOKEN_ADDRESS = '8WKems1g6ihTGkAiNy71Vk81ax24zzkU7BNgCogJpump';
export const SOLANA_TOKEN_PROGRAM_ID = 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA'; // Solana's SPL Token Program ID
export const ALCHEMY_RPC = 'https://solana-mainnet.g.alchemy.com/v2/jhWjtJ51hY7NmfwKkU6-NpFf3hIzIrT-';

// Base requirements for chapters (before dynamic multiplier)
export const BASE_REQUIREMENTS: BaseRequirements = {
  1: 0,          // Free chapter
  2: 10_000,     // 10k tokens
  3: 25_000,     // 25k tokens
  4: 50_000,     // 50k tokens
  5: 100_000,    // 100k tokens
  6: 150_000,    // 150k tokens
  7: 200_000,    // 200k tokens
  8: 300_000,    // 300k tokens
  9: 400_000,    // 400k tokens
  10: 500_000,   // 500k tokens
};

// Dynamic scaling configuration
export const MAX_MULTIPLIER = 3;           // Maximum price multiplier
export const HOLDERS_PER_MULTIPLIER = 100; // Number of holders that increases multiplier by 1
